<template>
  <div style="width: 100%;">
    <template v-if="!end">
      <div class="flex w100">
        <div class="label-width flex_shrink txt_right">选择文件</div>
        <div class="flex1">
          <div class="ex-box mb20 flex_items flex_center f14">
            <!-- <form id="downForm" :action="action" method="POST" target="downloadIframe" enctype="multipart/form-data"> -->
            <div class="sub_btn cf page_main_bg f14">
              选择文件
              <input type="file" @change="uploadFile($event)" class="file" id="dia-file" name="file">
            </div>
            <!-- <input type="hidden" name="api_token" :value="api_token" /> -->
            <!-- </form> -->
            <div style="color: #909399;">{{ fileName ? fileName : '未选择任何文件' }}</div>
          </div>
          <a :href="tempUrl" :download="downloadName + '.xlsx'" v-if="type != 10">
            <div style="color: #909399;" class="f14 flex flex_items">
              <img src="@/assets/index/dp-2.png" class="mini-icon mr10">下载模版
            </div>
          </a>
        </div>
      </div>
      <div class="flex flex_end">
        <div class="sub_btn cf page_main_bg f14 pointer" @click="submit">
          导入
        </div>
      </div>
    </template>
    <template v-else>
      <div class="flex flex_center flex_items flex_column w100">
        <img src="@/assets/index/gou.png" class="gou" v-if="!msg || msg.length == 0">
        <img src="@/assets/index/th.png" class="gou" v-else>
        <div style="max-height: 50vh;overflow-y: auto;" v-if="msg && msg.length != 0" class="msg-box">
          <div v-for="(item, index) in msg" :class="index == msg.length - 1 ? '' : 'mb10'" style="color: #909399;">{{
            item }}</div>
        </div>
        <div class="txt_center" v-if="!msg || msg.length == 0">导入成功</div>
      </div>
    </template>
  </div>
</template>
<script>
import { downloadUrl, template, downloadName } from '@/utils/downloadUrl'
export default {
  name: '',
  components: {

  },
  mixins: [],
  props: {
    type: 0,//是哪个页面在调用
    upData: null,//额外参数
    url: '',//导入链接
    templateUrl: '',//模板下载链接
  },
  data() {
    return {
      fileName: '',
      api_token: '',
      action: '',
      file: '',
      tempUrl: '', //模板
      file: null,
      msg: [],
      end: false,
      downloadName: ''
    }
  },
  watch: {

  },
  created() {
    // this.resetData()
  },
  methods: {
    resetData() {
      this.api_token = localStorage.getItem('token');
      this.action = downloadUrl(this.type);
      this.downloadName = downloadName(this.type,this.upData ? this.upData.is_member : '')
      console.log(downloadName(this.type,this.upData ? this.upData.is_member : ''),'a===');
      
      this.fileName = '';
      if (this.type == 5 || this.type == 6) {
        this.tempUrl = this.type == 5 ? template(5, this.upData.is_member) : template(99, this.templateUrl);
      } else if(this.type == 9){
        let examine_open = localStorage.getItem('examine_open') == 1 ? 2 : ''
        this.tempUrl =  template(99, 'system/manage'+examine_open+'.xlsx')
      }else{
        this.tempUrl = template(this.type)
      }
      console.log(this.url, this.tempUrl);
      this.end = false;
      this.$nextTick(r => {
        document.getElementById('dia-file').value = ''

      })
      this.msg = []
    },
    uploadFile(file) {
      // console.log(file.target.files[0], 7888);
      if (file) {
        this.file = file.target.files[0];
        this.fileName = file.target.files[0].name;
      }
      var obj = document.getElementById('dia-file') ; 
      obj.value = '';
    },
    submit() {
      const fromData = new FormData()
      fromData.append('file', this.file)
      fromData.append('api_token', this.api_token)
      if (this.upData) {
        for (let k in this.upData) {
          fromData.append(k, this.upData[k])
        }
      }
      this.api.postUrl(this.url ? this.url : this.action, fromData).then(r => {
        if (r.code == 200) {
          this.$emit('uploadFile', r.data)
          this.end = true;
          this.msg = r.data.msg
          console.log(this.msg);

        }
      })
      // document.getElementById("downForm").submit();
    }
  }
};
</script>
<style scoped>
.ex-box {
  flex: 1;
  height: 150px;
  background: #F5FAFF;
  border-radius: 4px 4px 4px 4px;
  border: 1px solid #DCDFE6;
  background: #F5FAFF;
  flex-direction: column;
}

.label-width {
  width: 70px;
}

.sub_btn {
  width: 76px;
  height: 40px;
  margin-bottom: 12px;
  position: relative;
}

.file {
  position: absolute;
  left: 0;
  top: 0;
  opacity: 0;
  width: 100%;
  height: 100%;
  z-index: 2;
}

.gou {
  width: 48px;
  height: 48px;
  margin-bottom: 32px;
}

.msg-box {
  background: #F5FAFF;
  border-radius: 0px 0px 0px 0px;
  padding: 20px;
  width: 100%;
}
</style>